<footer class="bg-[#050d1a] text-slate-300">
  <!-- Sección Contacto (solo en inicio) -->
  <div class="bg-[#0f172a]" *ngIf="showContactForm">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-[4.5rem]">
    <div class="grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-12 items-start">
      <!-- Info de contacto -->
      <div>
        <h2 class="text-[clamp(1.5rem,3vw,2rem)] font-extrabold text-white mb-1 leading-tight">{{'contacto.message' | translate}}</h2>
        <h3 class="text-base text-lime-400 font-bold mb-3">Queremos Escucharte</h3>
        <p class="mb-[1.4rem] text-slate-400 text-sm leading-relaxed">Déjanos tus datos y un asesor se comunicará contigo a la brevedad.</p>

        <div class="space-y-[0.9rem]">
          <div class="flex items-center text-sm">
            <div class="bg-blue-700 w-9 h-9 rounded-full mr-3 flex items-center justify-center flex-shrink-0">
              <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
            </div>
            <span class="text-slate-200">{{telefono}}</span>
          </div>
          <div class="flex items-center text-sm">
            <div class="bg-blue-700 w-9 h-9 rounded-full mr-3 flex items-center justify-center flex-shrink-0">
              <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
            </div>
            <span class="text-slate-200">{{correo}}</span>
          </div>
        </div>
      </div>

      <!-- Formulario -->
      <div class="bg-slate-800 p-8 rounded-2xl border border-slate-700 shadow-xl">
        <form [ngClass]="{ 'form-validated': submitted }"
              [formGroup]="form"
              novalidate
              (focusin)="enableCaptcha()"
              (ngSubmit)="onSubmit()">
          
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
            <div>
              <label for="footer-contacto.nombre" class="block text-sm font-medium text-slate-300 mb-2">
                {{'main.name' | translate}}
              </label>
              <input id="footer-contacto.nombre"
                type="text"
                required
                formControlName="nombre"
                placeholder="Tu nombre"
                class="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500 transition-colors">
              <small class="text-red-400 text-xs mt-1 block" *ngIf="isInvalid('nombre', 'required')">
                {{'validations.required' | translate}}
              </small>
            </div>

            <div>
              <label for="footer-contacto.email" class="block text-sm font-medium text-slate-300 mb-2">
                {{'main.email' | translate}}
              </label>
              <input id="footer-contacto.email"
                type="email"
                required
                formControlName="email"
                placeholder="correo@ejemplo.com"
                class="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500 transition-colors">
              <small class="text-red-400 text-xs mt-1 block" *ngIf="isInvalid('email', 'required')">
                {{'validations.required' | translate}}
              </small>
            </div>
          </div>

          <!-- POST /contactos exige `phone` (10 dígitos). -->
          <div class="mb-4">
            <label for="footer-contacto.telefono" class="block text-sm font-medium text-slate-300 mb-2">
              {{'contacto.phone' | translate}}
            </label>
            <input id="footer-contacto.telefono"
              type="tel"
              required
              maxlength="10"
              formControlName="telefono"
              placeholder="6691234567"
              class="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500 transition-colors">
            <small class="text-red-400 text-xs mt-1 block" *ngIf="isInvalid('telefono', 'required')">
              {{'validations.phone' | translate}}
            </small>
          </div>

          <div class="mb-4">
            <label for="footer-contacto.comentario" class="block text-sm font-medium text-slate-300 mb-2">
              {{'contacto.comment' | translate}}
            </label>
            <textarea id="footer-contacto.comentario"
              rows="4"
              required
              formControlName="comentario"
              placeholder="Escribe tu mensaje aquí..."
              class="w-full bg-slate-900 border border-slate-700 rounded-lg px-4 py-3 text-white placeholder-slate-500 focus:outline-none focus:border-blue-500 transition-colors resize-none"></textarea>
            <small class="text-red-400 text-xs mt-1 block" *ngIf="isInvalid('comentario', 'required')">
              {{'validations.required' | translate}}
            </small>
          </div>

          <!-- Contenedor con alto reservado para evitar CLS; el reCAPTCHA se carga diferido -->
          <div #captchaSlot class="my-4 min-h-[78px]">
            <re-captcha
              *ngIf="showCaptcha"
              #reCaptcha
              required
              class="g-recaptcha"
              [siteKey]="captchaPublicKey"
              (resolved)="onCompleteCaptcha($event)"></re-captcha>
          </div>

          <div class="bg-green-900/30 border border-green-700 text-green-400 rounded-lg p-3 mb-5 flex items-center" *ngIf="successalert">
            <svg class="w-5 h-5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>
            <span>{{'contacto.complete_send' | translate}}</span>
          </div>

          <button type="submit"
            [disabled]="form.invalid"
            class="w-full bg-blue-700 hover:bg-blue-800 disabled:bg-blue-700/70 disabled:cursor-not-allowed text-white font-bold py-3.5 px-4 rounded-lg transition-colors text-sm shadow-lg">
            Enviar mensaje
          </button>
        </form>
      </div>
    </div>
    </div>
  </div>

  <!-- Separador -->
  <div class="border-t border-slate-800" *ngIf="showContactForm"></div>

  <!-- Footer Principal -->
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-12 border-b border-slate-800">

      <!-- Columna 1: Logo y descripción -->
      <div class="lg:col-span-1">
        <a routerLink="/" class="inline-block hover:opacity-80 transition-opacity">
          <img src="assets/images/logotipo-pmm-blanco.svg" alt="PMM Paquetería y Mensajería" class="h-10 w-auto" width="355" height="132">
        </a>
        <p class="mt-3 text-slate-400 text-sm leading-relaxed">
          Soluciones logísticas a la medida.<br>Tu carga segura, a tiempo, siempre.
        </p>
        <!-- Redes Sociales -->
        <div class="flex space-x-2 mt-6">
          <a *ngFor="let info of redesSociales" [href]="info.url" target="_blank" rel="noopener" [title]="info.title"
             class="bg-slate-800 hover:bg-blue-700 w-[34px] h-[34px] flex items-center justify-center rounded-full transition-colors no-underline text-slate-400 hover:text-white">
            <fa-icon [icon]="icons[info.icon]"></fa-icon>
          </a>
        </div>
      </div>

      <!-- Columna 2: Servicios -->
      <div>
        <h4 class="text-white font-bold text-sm uppercase tracking-wider mb-4">Servicios</h4>
        <ul class="space-y-2.5 list-none p-0 m-0">
          <li><a routerLink="/servicios/entrega-dom" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">Entrega a Domicilio</a></li>
          <li><a routerLink="/servicios/ocurre" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">Servicio Ocurre</a></li>
          <li><a routerLink="/servicios/recoleccion" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">Recolección a Domicilio</a></li>
          <li><a routerLink="/servicios/valor-declarado" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">Valor Declarado</a></li>
          <li><a routerLink="/servicios/acuse" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">Acuse de Recibo</a></li>
        </ul>
      </div>

      <!-- Columna 3: Enlaces rápidos -->
      <div>
        <h4 class="text-white font-bold text-sm uppercase tracking-wider mb-4">Enlaces</h4>
        <ul class="space-y-2.5 list-none p-0 m-0">
          <li><a routerLink="/cotizador" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">Cotizador</a></li>
          <li><a routerLink="/rastreo" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">Rastreo de Envíos</a></li>
          <li><a routerLink="/facturacion" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">Facturación</a></li>
          <li><a routerLink="/cobertura" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">Cobertura</a></li>
          <li><a routerLink="/portalpagos" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">Portal de Pagos</a></li>
          <li><a routerLink="/bolsa-trabajo" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">Bolsa de Trabajo</a></li>
        </ul>
      </div>

      <!-- Columna 4: Contacto -->
      <div>
        <h4 class="text-white font-bold text-sm uppercase tracking-wider mb-4">Contacto</h4>
        <div class="space-y-4">
          <div class="flex items-center">
            <div class="bg-slate-800 p-2 rounded-full mr-3 flex-shrink-0">
              <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
            </div>
            <a [href]="'tel:' + telefono" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">{{telefono}}</a>
          </div>
          <div class="flex items-center">
            <div class="bg-slate-800 p-2 rounded-full mr-3 flex-shrink-0">
              <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
            </div>
            <a [href]="'mailto:' + correo" class="text-slate-400 hover:text-white text-sm transition-colors no-underline">{{correo}}</a>
          </div>
          <div class="flex items-start">
            <div class="bg-blue-900/50 p-2 rounded-full mr-3 flex-shrink-0 mt-0.5">
              <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
            </div>
            <div class="text-slate-400 text-sm">
              <p class="mb-0" *ngFor="let h of horarios">{{h}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Footer Bottom -->
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row justify-between items-center gap-3 text-center">
    <p class="text-xs text-slate-400 mb-0">
      © {{currentYear}} Entregas Puntuales S de R.L de C.V. Todos los derechos reservados.
    </p>
    <div class="flex gap-5">
      <a routerLink="/aviso-de-privacidad" class="text-xs text-slate-400 hover:text-white transition-colors no-underline">Aviso de Privacidad</a>
      <a routerLink="/terminos-y-condiciones" class="text-xs text-slate-400 hover:text-white transition-colors no-underline">Términos y Condiciones</a>
    </div>
  </div>
</footer>

